module.exports = __webpack_public_path__ + "static/img/scene3.41b9144c.jpg";